import React from 'react';
import { AlertCircle } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { useLanguage } from '../contexts/LanguageContext';
export function Remboursement() {
  const {
    t
  } = useLanguage();
  return <>
      <PageHeader eyebrow={t.footer.legalTitle} titleLead={t.refund.title} titleAccent="" data-id="element-476" data-mp="1jf59vg1pr0f9" />

      <section className="bg-creme py-20 md:py-28" data-id="element-477" data-mp="1ej7txaud3w30">
        <div className="mx-auto max-w-3xl px-6 md:px-12" data-id="element-478" data-mp="qsc7yucl7v3o">
          <div className="border border-caramel/30 bg-creme-dark p-8 md:p-12" data-id="element-479" data-mp="ls6cf3375ogb">
            <AlertCircle size={26} strokeWidth={1.25} className="mb-6 text-caramel" aria-hidden="true" data-id="element-480" data-mp="luj0lxzjsv1t" />
            <div className="space-y-6 font-sans font-light leading-relaxed text-cacao-700" data-id="element-481" data-mp="vosu5j087ze4">
              {t.refund.paragraphs.map(paragraph => <p key={paragraph.slice(0, 32)} data-id="element-482" data-mp="275stgykzrehn">{paragraph}</p>)}
            </div>
          </div>

          <p className="mt-8 border-l-2 border-caramel pl-5 font-sans font-light leading-relaxed text-cacao-800" data-id="element-483" data-mp="335fvwqkdj89d">
            {t.cart.notice}
          </p>
        </div>
      </section>
    </>;
}